import { render, staticRenderFns } from "./AgentIntro.vue?vue&type=template&id=5fbf04d4"
import script from "./AgentIntro.vue?vue&type=script&lang=ts"
export * from "./AgentIntro.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports